import classNames from "classnames";
import React, { ButtonHTMLAttributes } from "react";
import { useBoolean } from "../../../hooks/common/useBoolean";
import { AddLinkIcon } from "../icons/AddLinkIcon";

export function AddLinkButton(props: ButtonHTMLAttributes<any>) {

    const [openTooltip, open, close,] = useBoolean();

    return (
        <div className="add_link_button">
            <button {...props} onMouseEnter={open} onMouseLeave={close}>
                <AddLinkIcon />
            </button>
            <div className={classNames("tooltip", { "active": openTooltip })}>
                リンクを追加
            </div>
        </div>
    );
}